// Base URL of the backend API.
//
// Local development: defaults to the Uvicorn dev server on localhost:8000.
// Cloud production: set REACT_APP_API_BASE_URL at build time (e.g. in
// frontend/.env.production or the Static Web App build configuration) to the
// backend Web App URL, e.g. "https://shelterstone-backend.azurewebsites.net".
//
// The trailing slash (if any) is stripped so callers can safely append paths.
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000"
).replace(/\/$/, "");
